import * as React from 'react';
import PropTypes from 'prop-types';
import Svg, { Path } from 'react-native-svg';
import { colors } from '../constants';

const SvgOffers = ({ active, size }) => (
  <Svg height={size} viewBox="0 0 24 24" width={size}>
    <Path
      d="M2.72 10.293c0 .054.027.107.053.16.027.054.054.107.054.16 0 0 0 .107.106.107.054.053.08.107.107.16.027.053.053.107.107.16l.106.107c.041.04.066.081.088.116.034.056.06.097.126.097l.106.107c.214.32.534.533.854.746l.106.107c.054.053.107.08.16.107a.557.557 0 01.16.106c.054 0 .08.027.107.054.027.026.053.053.107.053.053 0 .106.027.16.053a.379.379 0 00.16.054c.106 0 .213.106.213.106.107 0 .213.107.213.107.054 0 .107.027.16.053.054.027.107.054.16.054.054 0 .08.026.107.053.027.027.053.053.107.053.053 0 .106.027.16.054.053.026.106.053.16.053v-.533c0-3.947 2.666-7.254 6.186-8.32C12 4.213 10.933 4 9.867 4 5.707 4 2.4 6.24 2.4 8.907c0 .533.107.96.32 1.386zm4.587 6.08c-2.667-.64-4.587-2.24-4.907-4.16 1.067 1.174 2.56 2.027 4.373 2.56.107.534.32 1.067.534 1.6zm-4.8-1.386c1.173 1.386 3.2 2.453 5.653 2.773.427.533.853 1.067 1.493 1.6-3.733 0-6.826-1.92-7.146-4.373zm5.44-2.24c0-3.947 3.2-7.254 7.253-7.254s7.36 3.307 7.253 7.254c0 3.946-3.2 7.253-7.253 7.253-3.947 0-7.253-3.2-7.253-7.253zm9.173.64c.213-.214.427-.32.747-.427.32-.107.533-.427.533-.853-.107-.427-.32-.64-.747-.64h-1.28l-.533-1.494c-.213-.64-.853-.746-1.173 0-.107.267-.187.507-.267.747-.08.24-.16.48-.267.747a2.601 2.601 0 01-1.28 0c-.746-.107-.96.746-.426 1.173.32.32.746.64 1.066.853-.183.459-.288.997-.381 1.477l-.045.23c0 .32.106.747.32.853.32.107.64-.213.96-.533.32-.32.64-.64.96-.853.266.16.48.346.693.533.213.187.427.373.693.533.64.427 1.28-.106.96-.746-.265-.442-.384-.958-.477-1.364l-.056-.236z"
      fill={active ? colors.itemActive : colors.itemInactive}
    />
  </Svg>
);

SvgOffers.defaultProps = {
  active: false,
  size: 26
};

SvgOffers.propTypes = {
  // optional
  active: PropTypes.bool,
  size: PropTypes.number
};

export default SvgOffers;
